import React from 'react';

const Basketball = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='13.99'
            viewBox='0 0 14 13.99'
            className={className}
        >
            <g id='Basketball' transform='translate(-49.997 -68.005)'>
                <path
                    id='Path_3044'
                    data-name='Path 3044'
                    d='M52.206,79.36a6.965,6.965,0,0,0,3.626,1.521V74.688h-1.7A8.684,8.684,0,0,1,52.206,79.36Z'
                    transform='translate(0.368 1.114)'
                />
                <path
                    id='Path_3045'
                    data-name='Path 3045'
                    d='M56.688,80.88a7.462,7.462,0,0,0,3.63-1.518,8.643,8.643,0,0,1-1.924-4.677H56.688Z'
                    transform='translate(1.116 1.114)'
                />
                <path
                    id='Path_3046'
                    data-name='Path 3046'
                    d='M50.006,74.688a6.975,6.975,0,0,0,1.444,3.528,6.945,6.945,0,0,0,1.444-3.528Z'
                    transform='translate(0.002 1.114)'
                />
                <path
                    id='Path_3047'
                    data-name='Path 3047'
                    d='M59.521,74.686a6.963,6.963,0,0,0,1.444,3.531,6.943,6.943,0,0,0,1.443-3.531Z'
                    transform='translate(1.588 1.114)'
                />
                <path
                    id='Path_3048'
                    data-name='Path 3048'
                    d='M52.3,69.651c.124.163.246.324.358.49a8.536,8.536,0,0,1,1.465,4.093l.856-.027.883,0-.026-6.2a7.061,7.061,0,0,0-3.632,1.52Z'
                    transform='translate(0.369 0)'
                />
                <path
                    id='Path_3049'
                    data-name='Path 3049'
                    d='M58.45,74.208c-.05-.047-.041-.145-.028-.242a8.433,8.433,0,0,1,1.245-3.526c.152-.242.319-.474.489-.709l.152-.211a7.037,7.037,0,0,0-3.62-1.514v6.2Z'
                    transform='translate(1.115 0)'
                />
                <path
                    id='Path_3050'
                    data-name='Path 3050'
                    d='M52.9,73.82a7.035,7.035,0,0,0-1.448-3.534A7.724,7.724,0,0,0,50,73.82Z'
                    transform='translate(0 0.38)'
                />
                <path
                    id='Path_3051'
                    data-name='Path 3051'
                    d='M62.409,73.819a6.95,6.95,0,0,0-1.443-3.529,6.963,6.963,0,0,0-1.444,3.529Z'
                    transform='translate(1.588 0.381)'
                />
            </g>
        </svg>
    );
};

export default Basketball;
